import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { compareByName } from '@/utils/resultsHelper';
import { uniqueDictionariesInClauses, findQuery } from '../../state/shared';
import { addDictionaryToCohort } from '../../actions';
import QueryDictionariesDropdownItems from '../components/QueryDictionariesDropdownItems';

const QueryDictionariesDropdown = ({
  category,
  code,
  dictionaries,
  disabled,
  addDictionary,
  queryUUID,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      floating
      item
      className="aridhia-query-dictionaries-dropdown right max-content"
      disabled={disabled || dictionaries.length === 0}
      text={intl.formatMessage({ id: 'cohort.dictionaries.add' })}
    >
      <Dropdown.Menu>
        <QueryDictionariesDropdownItems
          category={category}
          code={code}
          queryUUID={queryUUID}
          dictionaries={dictionaries}
          onChange={addDictionary}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { query } = findQuery(cohorts, ownProps);
  const codes = uniqueDictionariesInClauses(query).map((dict) => dict.code);
  const dictionaries = query.dataset.dictionaries.filter((r) => (!codes.includes(r.code))).sort(compareByName);

  return {
    dictionaries,
  };
};

const mapDispatchToProps = {
  addDictionary: addDictionaryToCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryDictionariesDropdown);
